import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

export type HandlerType = Parameters<typeof RequestDataFromApi>[0];

addToChainAfter(chain, RequestDataFromApi, ParseInvoiceNumbers);

function ParseInvoiceNumbers(props: HandlerType) {
    if (props.apiResult && props.apiResult.properties["invoiceNumbers"]) {
        props.apiResult.relatedInvoiceNumbers = props.apiResult.properties["invoiceNumbers"].split("|");
        delete props.apiResult.properties["invoiceNumbers"];
    }
}
